import { useCallback } from 'react';

export const useScrollTo = (classname: string) => {
  if (!classname || !classname.trim() || classname.indexOf('.') !== 0) {
    throw new Error('classname is required');
  }

  const scrollTo = useCallback(() => {
    setTimeout(() => {
      const elt = document.querySelector(classname);
      const scrollable = elt?.parentElement?.parentElement;
      if (!scrollable) {
        return;
      }

      const behavior = 'smooth';
      const shouldUseScrollIntoView = !!document.documentElement.scrollIntoView;
      if (shouldUseScrollIntoView) {
        scrollable.scrollIntoView({ behavior });
      } else {
        const topPosition = scrollable.getBoundingClientRect().top;
        window.scrollBy({ behavior, left: 0, top: topPosition });
      }

      const errorInput = scrollable.querySelector('input, textarea, select') as HTMLElement;
      if (errorInput) {
        errorInput.focus();
      }
    }, 200);
  }, [classname]);

  return { scrollTo };
};
